import { render } from "./App.vue?vue&type=template&id=bba6f952"
const script = {}

import "./App.vue?vue&type=style&index=0&id=bba6f952&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])